import React, { memo, useState, useRef, useEffect } from 'react'
import {
  Button,
  HeadingText,
  TextInput,
  CaptionText,
  Alert,
  Link,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import ReCAPTCHA from 'react-google-recaptcha'
import Spinner from '../../../screens/dsr/common/dsr-spinner'
import asASlide from '../../common/as-a-slide'
import {
  serverData,
  getFeatureValue,
  isEmail,
  isEmptyOrWhiteSpace,
  fptiCustomImpression,
  fptiCustomClick,
} from '../../../utils'

import { LOGGEDOUT_TRACK_REQUEST_API } from '../../../constants/constants'
import { post } from '../../../utils/ajax.js'

import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
const loggedOutFPTI = DATAPRIVACY_FPTI.LOGGED_OUT

const dsrRecaptchaKey = getFeatureValue('dsrRecaptchaSiteKey')
const recaptchaFlag = getFeatureValue('recaptchaFlagToDisplay')

const TrackYourRequest = memo((props) => {
  const [showAlert, setShowAlert] = useState(false)
  const [showSpinner, setShowSpinner] = useState(false)
  const [formValues, setFormValues] = useState()
  const [errfieldObj, setErrfieldObj] = useState()
  const [impressionDone, setImpressionDone] = useState(false)
  const { onModalNavigate, updateModalStore } = props

  const userObj = {
    requestid: '',
    lname: '',
    captchaToken: '',
  }

  const errorObj = {}

  useEffect(() => {
    for (const i in userObj) {
      errorObj[i] = false
    }
    setFormValues({ ...userObj })
    setErrfieldObj({ ...errorObj })

    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(loggedOutFPTI.TRACK_YOUR_DATA_REQUEST_IMPRESSION)
    }
  }, [])

  const recaptchaRef = useRef(null)
  window.recaptchaOptions = {
    useRecaptchaNet: true,
  }

  const validateFields = () => {
    for (const i in errfieldObj) {
      errfieldObj[i] = isEmptyOrWhiteSpace(formValues[i])
    }
    const isvalidEmail = isEmail(formValues.email)
    errfieldObj.email = isvalidEmail
    setErrfieldObj({ errfieldObj, ...errfieldObj })
  }

  const handleContinue = (e) => {
    e.preventDefault()

    if (recaptchaFlag) {
      const ctoken = recaptchaRef.current.getValue()
      formValues.captchaToken = ctoken
    } else {
      formValues.captchaToken = 'testvalue'
    }

    validateFields()

    const isValid = Object.keys(formValues).some(
      (item) => formValues[item] === '',
    )
    if (!isValid) {
      const reqparams = {
        _csrf: serverData._csrf,
        fields: JSON.stringify(formValues),
      }
      postDARRequest(reqparams)
    }
  }

  async function postDARRequest(reqparams) {
    setShowSpinner(true)
    fptiCustomClick(loggedOutFPTI.TRACK_YOUR_DATA_REQUEST_CONTINUE_BTN)
    const response = await post(LOGGEDOUT_TRACK_REQUEST_API, reqparams)
    if (response && response.success) {
      const {
        customer: { name: { surname = '' } = {} },
      } = response.data
      if (surname.toLowerCase() === formValues.lname.toLowerCase()) {
        setShowSpinner(false)
        setShowAlert(false)
        updateModalStore({ dataResponse: response.data })
        onModalNavigate(1)
      } else {
        setShowSpinner(false)
        setShowAlert(true)
      }
    } else {
      setShowSpinner(false)
      setShowAlert(true)
    }
  }

  const handleChange = (evt) => {
    formValues[evt.target.name] = evt.target.value
  }

  return (
    <>
      {showSpinner && <Spinner />}
      {!showSpinner && (
        <>
          <HeadingText
            id="trackrequest-header"
            size="md"
            className="text-center requestForm-row"
          >
            <Message id="dsrLoggedout.trackyourrequest.header" />
          </HeadingText>

          <section className="page-body-container requestForm-row">
            <div className="inner-container">
              {errfieldObj && (
                <section className="data-request-page requestForm-section-row">
                  <form className="formcontainer">
                    {showAlert && (
                      <Alert
                        theme="v2"
                        className="requestForm-row"
                        type="error"
                        closeButton={{
                          onClick: () => {
                            setShowAlert(false)
                          },
                        }}
                      >
                        <Message id="dsrZettle.common.error.technical" />
                      </Alert>
                    )}

                    <div className="requestForm-row">
                      <TextInput
                        name="requestid"
                        label={
                          <Message id="dsrLoggedout.trackyourrequest.form.requestid.label" />
                        }
                        defaultValue={formValues.requestid}
                        theme="v2"
                        helperText={
                          <Message id="dsrLoggedout.trackyourrequest.form.requestid.tooltip" />
                        }
                        onChange={handleChange}
                        errorText={
                          errfieldObj.requestid ? (
                            <Message id="dsrLoggedout.trackyourrequest.form.requestid.validation.required" />
                          ) : (
                            ''
                          )
                        }
                      />
                    </div>

                    <div className="requestForm-row">
                      <TextInput
                        name="lname"
                        label={<Message id="dsrLoggedout.darform.lnlabel" />}
                        theme="v2"
                        defaultValue={formValues.lname}
                        onChange={handleChange}
                        errorText={
                          errfieldObj.lname ? (
                            <Message id="dsrLoggedout.darform.ln.validation.required" />
                          ) : (
                            ''
                          )
                        }
                      />
                    </div>

                    {recaptchaFlag && (
                      <div className="captcha-center requestForm-row">
                        <div>
                          <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={dsrRecaptchaKey.sitekey || ''}
                          />
                          {errfieldObj.captchaToken ? (
                            <div className="customError">
                              <Alert type="error" className="errorText">
                                <Message id="dsrLoggedout.darform.captcha.required" />
                              </Alert>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    )}

                    <div className="text-center requestForm-row">
                      <Button
                        theme="v2"
                        id="continuebtn"
                        onClick={handleContinue}
                      >
                        <Message id="dsrLoggedout.trackyourrequest.continuebtn" />
                      </Button>
                    </div>
                  </form>

                  <div className="requestForm-row">
                    <CaptionText className="text-center">
                      <Message
                        id="dsrLoggedout.clickcontinuebtn"
                        link={(innerMessage) => (
                          <Link
                            href={`https://${serverData.cdnPayPalDomain}/en/webapps/mpp/ua/privacy-full#3`}
                            id="privacy_statment_link"
                            theme="v2"
                          >
                            {innerMessage}
                          </Link>
                        )}
                      />
                    </CaptionText>
                  </div>
                </section>
              )}
            </div>
          </section>
        </>
      )}
    </>
  )
})
TrackYourRequest.displayName = 'TrackYourRequest'
export default asASlide({ position: 0 })(TrackYourRequest)
